<template>
  <HeaderApp />
  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      ($store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
  >
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("roles_list") }}
      </h1>
    </div>

    <!-- Table Section -->
    <div class="">
      <div class="relative overflow-x-auto">
        <div class="flex items-center justify-between pb-4 mx-5">
          <div class="flex items-center space-x-4">
            <BaseInput
              :modelValue="$store.state.role_list.search"
              @update:modelValue="handleSearchInput"
              :placeholder="$t('search')"
              :prefixIcon="'fa-solid fa-search'"
              class="w-40 md:w-full"
            />
          </div>
        </div>
        <!--in ltr change (text-right to text-left)-->
        <EasyDataTable
          :headers="headers"
          :items="filterItems"
          :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
          :alternating="false"
          :loading="isLoadingData"
          :table-class-name="isDark ? 'modern-dark-table mx-6' : 'mx-6'"
        >
          <template #default="{ column, sortDirection }">
            <div
              :class="`flex items-center space-x-2 ${
                $store.getters['isRtl'] ? 'justify-end' : 'justify-start'
              }`"
            >
              <span class="font-semibold text-gray-700 dark:text-gray-300">{{
                column.label
              }}</span>
              <span v-if="column.sortable" class="text-gray-400">
                <i
                  v-if="sortDirection === 'asc'"
                  class="fa-solid fa-arrow-up text-blue-500"
                ></i>
                <i
                  v-else-if="sortDirection === 'desc'"
                  class="fa-solid fa-arrow-down text-blue-500"
                ></i>
                <i v-else class="fa-solid fa-arrows-up-down text-gray-400"></i>
              </span>
            </div>
          </template>
          <template #item-actions="item">
            <a
              class="mx-1 my-1"
              :href="'role-list/' + item.ro_id"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '27',
                  action: 'detail',
                })
              "
            >
              <i
                class="fa-solid fa-pen text-center p-1 w-7 h-7 text-sm bg-blue-200 dark:bg-blue-300 rounded-md text-blue-500 mx-auto"
              >
                {{ item.text }}
              </i>
            </a>
            <button
              class="mx-1 my-1"
              @click="deleteItem(item.ro_id)"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '27',
                  action: 'delete',
                })
              "
            >
              <i
                class="fa-solid fa-trash text-center p-1 w-7 h-7 text-sm bg-red-200 dark:bg-red-300 rounded-md text-red-500 mx-auto"
              ></i>
            </button>
          </template>
          <template #loading>
            <div class="flex items-center justify-center py-8">
              <img
                src="../../assets/loading.webp"
                class="w-16 h-16 animate-pulse"
                alt="Loading..."
              />
            </div>
          </template>
          <template #item-created_at="item">
            {{ formatDate(item.created_at) }}
          </template>
          <template #empty-message>
            <div
              class="flex flex-col items-center justify-center py-12 text-gray-500 dark:text-gray-400"
            >
              <i class="fa-solid fa-inbox text-4xl mb-4"></i>
              <span class="text-lg font-medium">{{ $t("no_data_found") }}</span>
            </div>
          </template>
          <template
            #pagination="{ prevPage, nextPage, isFirstPage, isLastPage }"
          >
            <button :disabled="isFirstPage" @click="prevPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-right'
                    : ' fa-angle-left ')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button :disabled="isLastPage" @click="nextPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-left'
                    : ' fa-angle-right')
                "
              ></i>
            </button>
          </template>
        </EasyDataTable>
      </div>
    </div>
  </div>
  <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  <ResultDialog ref="ResultDialog"></ResultDialog>
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import { formatDate } from "../../utils/functions";
import ConfirmDialogue from "../../components/Modals/ConfirmDialogue.vue";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import "../../assets/css/modern-table.css";

export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    BaseInput,
    ConfirmDialogue,
    ResultDialog,
  },
  data() {
    return {
      firstName: "",
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      ro_name: "",
      inputType: "text",
      isSubmited: false,
      isSubmitedEdit: false,
      current: {},
    };
  },
  created() {
    this.getData();
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    getResultDialog(newValue, oldValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.role_list.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.role_list.isSuccess,
        });

        // Reset the deleteSuccess state after showing the dialog
        this.$store.commit("role_list/SET_DELETE_SUCCESS", false);
      }
    },
  },

  computed: {
    getResultDialog() {
      return this.$store.state.role_list.isShowResultDialog;
    },
    items() {
      return this.$store.state.role_list.items;
    },
    filterItems() {
      return this.$store.getters["role_list/filterItems"];
    },
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.role_list.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.role_list.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.role_list.isBtnEditLoading;
    },
    headers() {
      return [
        { text: "#", value: "ro_id", sortable: true },
        { text: this.$t("role_name"), value: "ro_name", sortable: true },
        { text: this.$t("created_at"), value: "created_at", sortable: true },
        { text: this.$t("actions"), value: "actions", sortable: false },
      ];
    },
  },

  methods: {
    formatDate(date) {
      return formatDate(date);
    },
    getData() {
      this.$store.dispatch("role_list/getItems");
    },
    handleSearchInput(value) {
      this.$store.commit("role_list/SET_SEARCH", value);
    },
    async addSaleItem(e) {
      e.preventDefault();
      //check form validation
      if (this.$store.state.role_list.isBtnLoading) return;

      this.isSubmited = true;
      if (this.checkRulesIsError(this.ro_name, "add").isError) {
        return;
      }
      this.$store.state.role_list.isBtnLoading = true;
      var res = await this.$store.dispatch(
        "role_list/addNewItem",
        this.ro_name
      );
      if (res.status == 200) {
        this.ro_name = "";
        this.isSubmited = false;
      }
    },
    checkRulesIsError(value, type) {
      var isError = false;
      var errorMsg = "";
      if (type == "add") {
        if (this.isSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      if (type == "edit") {
        if (this.isSubmitedEdit == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }

      for (const rule of this.rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    async deleteItem(id) {
      const ok = await this.$refs.confirmDialogue.show({
        message: this.$t("are_you_sure_remove_this_item") + id,
        okButton: this.$t("delete"),
      });
      if (ok) {
        this.$store.commit("role_list/REMOVE_ITEM", id);
        this.$store.dispatch("role_list/deleteItem", id);
      }
    },
    //edit
    async showModal(item) {
      this.current = item;
      await this.$refs.editModal.show();
    },
    async editItem(e) {
      e.preventDefault();
      this.isSubmitedEdit = true;
      if (this.checkRulesIsError(this.current.ro_name, "edit").isError) {
        return;
      }
      this.$store.state.role_list.isBtnEditLoading = true;
      var res = await this.$store.dispatch("role_list/editItem", {
        ro_id: this.current.ro_id,
        ro_name: this.current.ro_name,
      });

      this.isSubmitedEdit = false;
      this.$store.state.role_list.isBtnEditLoading = false;
      if (res.status == 200) {
        this.$refs.editModal.hide();
      }
    },
  },
};
</script>
